"use client";

import React from "react";
import { ArrowRight, CircleCheck, MessageCircle } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function TuVisionNuestraEstructura() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="18150" id="crecimiento-sin-complicaciones" className="bg-background overflow-hidden relative dark !py-12 md:!py-16 lg:!py-20">
      <div className="container mx-auto px-4 md:px-6 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 md:gap-8 lg:gap-12 items-center">
          {}
          <div ref={ref} className={`flex flex-col gap-8 max-w-2xl transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
            <h1 className="font-sans font-bold leading-[1.1] tracking-tighter text-foreground !text-4xl">Plataformas Inteligentes para Empresas Técnicas y Comerciales. <br />Marketing Digital. Portal de Negocios.</h1>

            <p className="text-lg leading-relaxed max-w-lg !text-[hsl(210,16%,93%)] md:text-xl">Desarrollo webs premium, automatización y&nbsp; AGENTES AI para empresas técnicas, industriales&nbsp;y comerciales que buscan evolucionar.</p>

            <div className="flex flex-col sm:flex-row gap-4 mt-4 md:mt-6">
              <Button asChild size="lg" className="h-14 px-8 text-lg font-bold bg-secondary text-secondary-foreground hover:bg-secondary/90 border-none hover:shadow-[0_0_30px_var(--color-secondary)] transition-all duration-300 animate-[pulse_3s_ease-in-out_infinite]">
                <Link to="#listo-para-crecer" onClick={e => {
                e.preventDefault();
                document.getElementById("listo-para-crecer")?.scrollIntoView({
                  behavior: "smooth"
                });
              }}>
                  Solicita diagnóstico gratis
                  <ArrowRight className="ml-2 h-5 w-5" />
                </Link>
              </Button>

              <Button asChild size="lg" className="h-14 px-8 text-lg font-bold bg-primary text-primary-foreground hover:bg-primary/90 border-none hover:shadow-[0_0_30px_var(--color-primary)] transition-all duration-300">
                <Link to="https://wa.me/34602505574" newTab>
                  <MessageCircle className="mr-2 h-5 w-5" />
                  Escríbeme por WhatsApp
                </Link>
              </Button>
              
              <Button asChild variant="outline" size="lg" className="h-14 px-8 text-lg border-primary/50 text-primary hover:bg-primary/10">
                <Link to="#todoloquetunegocionecesitaparacreceronline" onClick={e => {
                e.preventDefault();
                document.getElementById('todoloquetunegocionecesitaparacreceronline')?.scrollIntoView({
                  behavior: 'smooth'
                });
              }}>
                  Ver Servicios
                </Link>
              </Button>
            </div>

            <div className="flex items-center gap-6 text-sm font-medium text-muted-foreground mt-4">
              <div className="flex items-center gap-2">
                <CircleCheck className="h-4 w-4 text-primary" />
                <span>Resultados Reales</span>
              </div>
              <div className="flex items-center gap-2">
                <CircleCheck className="h-4 w-4 text-primary" />
                <span>Sistemas Inteligentes</span>
              </div>
            </div>
          </div>

          {}
          <div className={`relative transition-all duration-1000 delay-300 ease-out ${isVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-10"}`}>
            <div className="relative z-10 transform hover:scale-[1.02] transition-transform duration-500">
              {}
              <div className="absolute -inset-4 bg-primary/10 rounded-lg blur-3xl -z-10" />
              
              <Link to="#resultados-en-tu-sector" className="block cursor-pointer transition-all duration-500 hover:shadow-[0_0_30px_rgba(59,130,246,0.3)] rounded-lg" onClick={e => {
              e.preventDefault();
              document.getElementById("resultados-en-tu-sector")?.scrollIntoView({
                behavior: "smooth"
              });
            }}>
                <img src="https://recla360.com/wp-content/uploads/2026/05/Mecator_0.jpg" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1611697/img/browser_wireframe_3d.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1611697/img/browser_wireframe_3d.png-wvc-sizes" alt="Plataforma de automatización y soluciones AI Recla360" className="w-full object-contain drop-shadow-2xl rounded-lg h-auto max-h-[600px] md:max-h-[700px] lg:max-h-[800px]" loading="lazy" />
              </Link>
              
              {}
              <div className="absolute -bottom-4 -left-4 md:-bottom-6 md:-left-6 md:bottom-10 md:-left-10 bg-card border border-primary/20 p-4 rounded-xl shadow-xl flex items-center gap-3 animate-[bounce_4s_infinite]">
                <div className="bg-primary/20 p-2 rounded-lg">
                  <CircleCheck className="h-6 w-6 text-primary" />
                </div>
                <div>
                  <p className="text-xs text-muted-foreground font-semibold uppercase tracking-wider">
                    Evolución Digital
                  </p>
                  <p className="text-lg font-bold text-foreground">100%</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}